import React, { useState } from 'react';
import bg_img from '../assets/bg-img-1.jpg';
import { Link } from 'react-router-dom';
import useToken from '../context/useToken';
import axios from 'axios';

const ServiceCard = ({ id, image, title, description,fetchServices }) => {
  const token = useToken();
  const [showModal, setShowModal] = useState(false);
  const [newTitle, setNewTitle] = useState(title);
  const [newDescription, setNewDescription] = useState(description);
  const [newImage, setNewImage] = useState(image);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setNewImage(file); // Store the file for API upload
    }
  };

  const onEdit = async () => {
    try {
      const formData = new FormData();
      formData.append('title', newTitle || '');
      formData.append('isActive', true);
  
      if (newImage instanceof File) {
        formData.append('iconImage', newImage, newImage.name || 'iconImage.jpg');
      }
  
      const config = {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      };
  
      const response = await axios.put(
        `https://thecfagroup.org/v1/api/services/${id}`,
        formData,
        config
      );
  
      // Close the modal after saving
      setNewImage(response.data.iconImage);
      setShowModal(false);
    } catch (error) {
      console.error('Error updating service:', error);
    }
  };
  

  return (
    <div className="relative">
      <Link to={`/service/${id}`}>
        <div className='group flex flex-col items-start justify-center w-[23rem] h-[20rem] bg-[#f6f6f6] p-8 rounded-lg gap-3 shadow-sm hover:bg-gradient-to-r hover:from-[#0e7a58] hover:to-[#25a182] hover:cursor-pointer hover:-translate-y-2 transition-all duration-300'>
          {/* Image Row */}
          <div className='flex items-center justify-between gap-10'>
            <img src={newImage} className='w-14 h-10' alt="Service" />
            {token && <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="h-8 w-8 cursor-pointer text-gray-500 hover:text-gray-700"
              onClick={(e) => {
                e.preventDefault();
                setShowModal(true);
              }}
            >
              <path d="M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32l8.4-8.4Z" />
              <path d="M5.25 5.25a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3V13.5a.75.75 0 0 0-1.5 0v5.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5V8.25a1.5 1.5 0 0 1 1.5-1.5h5.25a.75.75 0 0 0 0-1.5H5.25Z" />
            </svg>}
          </div>

          <h3 className='text-xl font-semibold mb-2 text-[#1f1f25] group-hover:text-white'>{newTitle}</h3>
          {/* <p className='text-start text-xl text-[#717173] group-hover:text-white'>
            {`${newDescription.substring(0, 90)}...`}
          </p> */}
          <div dangerouslySetInnerHTML={{ __html: newDescription.substring(0, 90) }} className="py-8 text-black text-lg font-poppinsRegular" />
        </div>
      </Link>

      {/* Modal */}
      {showModal && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white p-6 rounded-lg w-[90%] max-w-lg max-h-[80vh] overflow-y-auto">
      <h2 className="text-2xl font-semibold mb-4">Edit Service</h2>

     {/* Input for Title */}
      <input
        type="text"
        value={newTitle}
        onChange={(e) => setNewTitle(e.target.value)}
        placeholder="Title"
        className="block w-full mb-4 p-2 border rounded"
      />
      
      <input
      type="file"
      accept="image/*"
      onChange={handleFileUpload}
      className="p-2 border border-gray-300 rounded w-full mb-4"
    />

      {/* Save Button */}
      <button
        onClick={onEdit}
        className="bg-[#25a182] text-white px-4 py-2 rounded-lg hover:bg-white hover:text-[#25a182] border border-[#25a182] transition-transform duration-300 transform hover:scale-105"
      >
        Save Changes
      </button>

      {/* Close Modal Button */}
      <button
        onClick={() => setShowModal(false)}
        className="ml-4 bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-transform duration-300 transform hover:scale-105"
      >
        Cancel
      </button>
    </div>
  </div>
)}

    </div>
  );
};

export default ServiceCard;
